module.exports = __webpack_public_path__ + "LatoLatin-Regular.3cd36578026d6c12eddf.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Regular.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Regular.woff2
// module chunks = styles